import { ErrorMessage } from './types'

import { AxiosError } from 'axios'

export class InvalidAccessTokenError extends Error {
    constructor() {
        super()
        this.name = 'INVALID_ACCESS_TOKEN'
        this.message = 'Invalid access token.'
    }
}

export class ServerErrors extends Error {
    errors: ErrorMessage[]
    originalError?: AxiosError

    constructor(errors: ErrorMessage[], originalError?: AxiosError) {
        super(errors[0]?.message)
        this.name = 'SERVER_ERRORS'
        this.errors = errors
        this.originalError = originalError
    }
}
